import React from 'react';
import MobileLeaveModal from 'components/Modal/MobileLeaveModal';
import { BackgroundColor } from 'styles/Global/colorSemantic';
import { ValueType } from 'models/Common/commonTypes';

import InfoContents from './InfoContents';

interface ClientInfoSummaryModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
    clientInfo: ValueType;
    selectedReason?: number | null;
    counselReasons?: Array<{ text: string }>;
    otherReason?: string;
}

export const ClientInfoSummaryModal: React.FC<ClientInfoSummaryModalProps> = ({ isOpen, onClose, onSubmit, clientInfo, selectedReason, counselReasons = [], otherReason = '' }) => {
    if (!isOpen) return null;

    return (
        <MobileLeaveModal
            title='이후에는 수정할 수 없습니다.'
            subTitle='이대로 검사를 시작할까요?'
            firstButton='아니요'
            secondButton='검사 시작'
            secondButtonType='fill'
            infoContentsPadding='0px'
            infoContentsBorderColor={BackgroundColor.color_background_primary_neutral}
            infoContentsBorderRadius='8px'
            infoContents={<InfoContents clientInfo={clientInfo} selectedReasonIdx={selectedReason} counselReasons={counselReasons} otherReason={otherReason} />}
            setIsLeaveModal={onClose}
            clickLeaveButtonInLeaveModal={onSubmit}
        />
    );
};
